import { useCountUp } from '../../hooks/useCountUp'

interface Props {
  value: string | number
}

const NUMBER_RE = /^(\D*)(-?[\d.,]+)(.*)$/

function parseValue(value: string | number): { prefix: string; numeric: number; suffix: string; raw: string } {
  if (typeof value === 'number') {
    return { prefix: '', numeric: value, suffix: '', raw: String(value) }
  }
  const match = value.match(NUMBER_RE)
  if (!match) return { prefix: value, numeric: NaN, suffix: '', raw: value }
  const [, prefix, num, suffix] = match
  const usesComma = num.includes(',') && (!num.includes('.') || num.lastIndexOf(',') > num.lastIndexOf('.'))
  const normalized = usesComma
    ? num.replace(/\./g, '').replace(',', '.')
    : num.replace(/,/g, '')
  return { prefix: prefix ?? '', numeric: Number(normalized), suffix: suffix ?? '', raw: value }
}

function formatLocale(n: number, integerOnly: boolean): string {
  if (integerOnly) return Math.round(n).toLocaleString('es-ES')
  return n.toLocaleString('es-ES', { maximumFractionDigits: 1 })
}

export function AnimatedNumber({ value }: Props) {
  const parsed = parseValue(value)
  const animated = useCountUp(Number.isFinite(parsed.numeric) ? parsed.numeric : 0)

  if (!Number.isFinite(parsed.numeric)) {
    return <>{parsed.raw}</>
  }

  const integerOnly = Number.isInteger(parsed.numeric)
  return (
    <>
      {parsed.prefix}
      {formatLocale(animated, integerOnly)}
      {parsed.suffix}
    </>
  )
}
